import { render, staticRenderFns } from "./DowntimeReasonWizard.vue?vue&type=template&id=e2c5aad4&scoped=true"
import script from "./DowntimeReasonWizard.vue?vue&type=script&lang=js"
export * from "./DowntimeReasonWizard.vue?vue&type=script&lang=js"
import style0 from "./DowntimeReasonWizard.vue?vue&type=style&index=0&id=e2c5aad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c5aad4",
  null
  
)

export default component.exports